<template>
  <v-card :key="item._key" class="my-2 py-2 px-2">
    <v-list-item desne>
      <v-list-item-avatar tile>
        <v-icon color="primary" v-if="!pay">assignment</v-icon>
        <v-checkbox :ripple="false" v-model="item.include" @change="$emit('select-shift',item)" v-else></v-checkbox>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="body-1 font-weight-bold">
          <span :class="`${item.status==='pending'?'amber--text darken-1':item.status==='Paid'||item.paymentAmount?'success--text':''} ${item.status==='pending'?'amber--text darken-1':''}`">
            {{item.logTitle}} {{item.status?' - '+item.status:item.logTitle==='Payment'?'':' - Not Paid'}}
          </span>
        </v-list-item-title>
        <v-list-item-subtitle class="subtitle font-weight-bold">
          {{item.shiftDate|formatShortDate}}:
          <span v-if="item.clockLog">{{item.secondsWorked|formatHoursWorked}}:{{item.secondsWorked|formatMinWorked}}:{{item.secondsWorked|formatSecWorked}}</span>
          <span v-if="item.logTitle==='Payment'"> ${{item.paymentAmount}}</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="subtitle font-weight-bold justify-space-between">
          <v-row no-gutters class="justify-space-between">
            <v-col cols="6" v-if="item.expenses">
              <span>
                <v-icon color="info" size="16">fa-file-invoice-dollar</v-icon> Expenses
              </span>
            </v-col>
            <v-col cols="6" v-if="item.manualTime">
              <span>
                <v-icon color="primary lighten-2" size="16">warning</v-icon> Manual Time
              </span>
            </v-col>
          </v-row>

        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon @click="show=!show" :disabled="item.logTitle==='Payment'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="show"></v-divider>
    <v-expand-transition>
      <div v-show="show">
        <v-list-item v-if="item.clockLog">
          <v-list-item-avatar>
            <v-icon>update</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <template v-for="log in item.clockLog">
              <span :key="log._key">
                <b>{{log.state}}:</b><span class="caption"> {{log.date|formatShortDate}} {{log.date|formatTime}}</span>
              </span>
            </template>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="item.expenses">
          <v-list-item-avatar>
            <v-icon color="info">fa-file-invoice-dollar</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-row no-gutters v-for="(expense,index) in item.expenses" :key="index" class="py-1">
              <v-col cols="12">
                <span class="font-weight-bold">Amount: </span><span> ${{expense.amount}}</span>
              </v-col>
              <v-col cols="12">
                <span class="font-weight-bold">Description: </span><span class="body-2"> {{expense.desc}}</span>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mx-2" v-if="item.manualTime"></v-divider>

        <v-list-item v-if="item.manualTime">
          <v-list-item-avatar>
            <v-icon color="primary lighten-2">warning</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-row no-gutters class="py-1">
              <v-col cols="12" class="pb-2">
                <span class="font-weight-bold">Hours: </span><span> {{parseFloat(item.secondsWorked/60/60).toFixed(2)}}</span>
              </v-col>
              <v-col cols="12">
                <span class="font-weight-bold">Reason: </span><span class="body-2"> {{item.reason}}</span>
              </v-col>
            </v-row>
          </v-list-item-content>

        </v-list-item>
        <v-divider class="mx-2" v-if="!isHefe&& item.status!=='Paid'"></v-divider>
        <v-row justify="center" v-if="!isHefe&& item.status!=='Paid'">
          <v-col cols="6">
            <v-btn  block v-if="item.clockLog&&item.status!=='Paid'" @click="manualTimeDialog = true">Manual Time</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
    <v-dialog v-model="manualTimeDialog" persistent max-width="290">
      <v-card class="py-1">
        <v-card-title class="title py-3">Enter Manual Time</v-card-title>
        <!-- <v-card-text>{{ $language.jobDetails['Are you sure you want to start this shift?'] }} -->
        <!-- </v-card-text> -->
        <v-layout column pa-2>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="true" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field outlined solo flat slot="activator" prepend-inner-icon="date_range" v-bind="attrs" v-on="on" v-model="shiftDate" clearable :label="$language.addJob['Start Date']" readonly></v-text-field>
            </template>
            <v-date-picker v-model="shiftDate" @change="menu2 = false"></v-date-picker>

          </v-menu>
          <v-text-field v-model="thisLog.hours" label="Hours" outlined single-line type="Number"></v-text-field>
          <v-textarea rows="4" outlined v-model="thisLog.reason" label="Reason"></v-textarea>
        </v-layout>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" >
            <v-col cols="5">
              <v-btn color="primary" text block  @click.native="manualTimeDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>

            </v-col>
            <v-col cols="5">
              <v-btn color="primary"  block @click.native="editTime" :disabled="!parseFloat(thisLog.hours)>0||parseFloat(thisLog.hours)<0" :loading="buttonLoading" class="">{{ $language.jobDetails['Submit'] }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['item', 'pendingShiftsFixed', 'pay', 'index', 'jobKey', 'isHefe'],
  data () {
    return {
      sub: '',
      show: false,
      manualTimeDialog: false,
      menu2: false,
      shiftDate: new Date().toISOString().slice(0, 10),
      buttonLoading: false,
      thisLog: {
        secondsWorked: null,
        manualTime: true
      }
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser'])
  },
  methods: {
    editTime () {
      this.thisLog.secondsWorked = parseFloat(this.thisLog.hours) * 3600
      this.thisLog.manualTime = true
      this.thisLog.shiftDate = this.shiftDate ? new Date(moment(this.shiftDate)) : new Date(moment())
      var updates = {}
      updates[`jobs/${this.jobKey}/applicants/${this.currentUser.uid}/jobLog/${this.item._key}/secondsWorked`] = this.thisLog.secondsWorked
      updates[`jobs/${this.jobKey}/applicants/${this.currentUser.uid}/jobLog/${this.item._key}/manualTime`] = this.thisLog.manualTime
      updates[`jobs/${this.jobKey}/applicants/${this.currentUser.uid}/jobLog/${this.item._key}/reason`] = this.thisLog.reason
      updates[`jobs/${this.jobKey}/applicants/${this.currentUser.uid}/jobLog/${this.item._key}/shiftDate`] = this.thisLog.shiftDate
      fb.database.ref().update(updates)
      this.thisLog = {
        hours: null,
        reason: ''
      }
      this.manualTimeDialog = false
    }
  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(moment(`${this.job.startDate}T${val.h} ${val.mm} ${val.A}`, ['HH.mm a']).format('hh:mm a'))
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    formatHour (val) {
      if (!val) {
        return '-'
      }
      return val === parseInt(1) ? 'hour' : 'hours'
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    }
  }
}
</script>
